import { Link } from 'react-router-dom';
import ParaglidingImage from './assets/Paragliding.jpg';

function ParaglidingPage() {
  return (
    <div className="tour-detail-page">
      <section className="hero-subpage paragliding-hero">
        <div className="hero-content">
          <h1>Ebamba's Exhilarating Paragliding Cape Town</h1>
          <p>Soar above the city and coastline for an unmatched perspective and thrill.</p>
        </div>
      </section>

      <section className="section-spacing light-bg">
        <div className="container">
          <h2 className="text-center">Fly High Above the Mother City</h2>
          <div className="content-intro">
            <img src={ParaglidingImage} alt="Paragliding Cape Town" className="tour-main-image" />
            <p>Experience the ultimate freedom and a bird's-eye view of Cape Town with Ebamba Travel & Tours' tandem paragliding experience. Launching from Signal Hill or Lion's Head (depending on wind conditions), you'll glide effortlessly through the sky, taking in panoramic vistas of Table Mountain, the V&A Waterfront, and the Atlantic Seaboard.</p>
            <p>Our experienced and certified instructors ensure a safe and exhilarating adventure for all skill levels. No prior experience is necessary – just a desire for adventure and an appreciation for incredible views. This is an activity that promises unforgettable memories and stunning photo opportunities.</p>
          </div>

          <h3 className="text-center mt-5">What to Expect on Your Paragliding Flight</h3>
          <div className="expect-grid">
            <div className="expect-item">
              <i className="fas fa-wind"></i>
              <h4>Expert Instructors</h4>
              <p>Fly in tandem with a highly qualified and experienced paragliding pilot, ensuring maximum safety.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-parachute-box"></i>
              <h4>Safe & Easy Launch</h4>
              <p>Simple take-off procedures from a gentle slope; no jumping required, just a few steps and you're airborne.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-mountain"></i>
              <h4>Spectacular Scenery</h4>
              <p>Enjoy unparalleled aerial views of Cape Town's iconic landmarks and stunning coastline.</p>
            </div>
            <div className="expect-item">
              <i className="fas fa-video"></i>
              <h4>Capture the Moment</h4>
              <p>Optional GoPro video and photo packages available to relive and share your flight experience.</p>
            </div>
          </div>

          <h3 className="text-center mt-5">Hear From Our Happy Fliers</h3>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Paragliding with Ebamba was absolutely incredible! The views were insane, and my pilot made me feel completely safe. Best adrenaline rush in Cape Town!"</p>
              <span>– Sophie T. from UK</span>
            </div>
            <div className="testimonial-card">
              <p>"A truly unique way to see Cape Town. The flight was smooth, breathtaking, and exhilarating. Highly recommend booking through Ebamba for this experience!"</p>
              <span>– Juan P. from Spain</span>
            </div>
          </div>

          <div className="text-center mt-5">
            <Link to="/contact" className="btn btn-primary large-btn tour-btn">Book Your Flight of a Lifetime</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default ParaglidingPage;
